<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r.PRODUCT_CODE + '  ' + r.DDC_CODE + ' - ' + r.TRADE_NAME"
                 [term]="t"></ngb-highlight>
</ng-template>

<app-page-header [heading]="'Purchase List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="row ">
    <div class="col-lg-8 d-flex justify-content-end align-items-center">
      <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/purchase/add-purchase"
         title="Create new purchase">&nbsp;<i
        class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
    </div>
    <div class="col-lg-4">
      <div class="input-group ">
        <input (keydown)="keyDownFunction($event)" [(ngModel)]="purchase_credit.search_purchase"
               class="form-control" id="typeahead-http"
               name="search_text" placeholder="Supplier Name/Invoice no/Invoice Date..." style="height:31px"
               type="text">
        <div class="input-group-append">
          <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
            <i *ngIf="purchase_credit.search_purchase != ''" class="fa fa-close"></i>
            <i *ngIf="purchase_credit.search_purchase == ''" class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                 style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>

  <div class="">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead class="text-center">
      <tr>
        <th width="1%">Sl#</th>
        <th>GRN No.</th>
        <th>Supplier Name</th>
        <th>Invoice Number</th>
        <th>Invoice Date</th>
        <th>VAT No</th>
        <th>Created User</th>
<!--        <th width=10%>Received Date</th>-->
        <th>Total Amount</th>
        <th>Action</th>
      </tr>
      <tr *ngIf="(purchase_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of purchase_data;let i=index" style="font-size: 12px">
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1"
            class="text-center">
          {{ i + 1 }}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1">
            {{data.GRN_NUMBER}}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1">
          {{ data.VENDOR_NAME }}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1">
          {{ data.INVOICE_NUMBER }}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1"
            class="text-center">
          {{ data.INVOICE_DATE }}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1">
          {{ data.CUSTOMER_TRN }}
        </td>
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1">
          {{ data.FIRSTNAME }}&nbsp;{{ data.LASTNAME }}
        </td>
<!--        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"-->
<!--            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"-->
<!--            [class.text-voilet]="data.FINALIZE == 1"-->
<!--            class="text-center">-->
<!--          {{ data.RECEIVED_DATE }}-->
<!--        </td>-->
        <td [class.text-primary]="data.VAT_CREDIT == 1 && data.FINALIZE == 0"
            [class.text-success]="data.RECEIVED == 1 && data.FINALIZE == 0"
            [class.text-voilet]="data.FINALIZE == 1"
            class="text-right">
          {{ data.TOTAL ? data.TOTAL : ''}}
        </td>
        <td class="text-center" width="10%">
          &nbsp;&nbsp;<button (click)="purached_items(data);open(content);" class="btn btn-xs btn-margin btn-info"
                              style="font-size: 10px;"
                              title="View"><i class="fa fa-eye"></i></button>
          <ng-container *ngIf="data.ATTACHMENTS">
            &nbsp;&nbsp;<button (click)="purached_items(data);open_file(files);" [disabled]="data.ATTACHMENTS == false"
                                class="btn btn-xs btn-margin btn-info"
                                style="font-size:10px" title="Files">
            <i class="fa fa-file"></i></button>
          </ng-container>
          <ng-container *ngIf="data.FINALIZE == 0">
            &nbsp;&nbsp;<button (click)="purached_items(data);bar(vat);vat_pop(data.PURCHASE_ID)"
                                class="btn btn-xs btn-margin btn-info" style="font-size:9px;"
                                title="VAT"><i
            class="fa fa-percent"></i></button>
            &nbsp;&nbsp;<button (click)="purached_items(data);credit(payment);payment_pop(data.PURCHASE_ID)"
                                class="btn btn-xs btn-margin btn-info" style="font-size:9px;"
                                title="Received Details"><i
            class="fa fa-get-pocket"></i></button>
            &nbsp;&nbsp;<button (click)="getPurchaseDetails(data.PURCHASE_ID);opens(editdata);"
                                class="btn btn-xs btn-margin btn-info"
                                style="font-size: 9px;" title="Edit"><i
            class="fa fa-edit"></i></button>
          </ng-container>
          <ng-container *ngIf="data.RECEIVED == 1 && data.FINALIZE == 0">
            &nbsp;&nbsp;<button (click)="finalize(data.PURCHASE_ID)" class="btn btn-xs btn-margin btn-info"
                                style="font-size:9px;"
                                title="Finalize"><i class="fa fa-check"></i></button>
          </ng-container>

        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="9">
          <div>
            <label class="col-lg-7 text-left" style="font-style: italic;">
              <i class="fa fa-circle text-success" style="font-size: 12px;"></i>&nbsp;&nbsp;Received &nbsp;&nbsp;
              <i class="fa fa-circle text-voilet" style="font-size: 12px;"></i>&nbsp;&nbsp;Finalized &nbsp;&nbsp;
            </label>
            <label class="col-lg-4 text-right" colspan="6" style="font-size:15px;font-weight: bold;">Grand Total
              :  {{ grand_total }}</label>
          </div>
        </td>
      </tr>
      </tfoot>
    </table>
    <app-pagination (pageChange)="getPurchaseList($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>

  </div>
  <ng-template #editdata let-modal>
    <div class="modal-header">
      <div class="pull-right ">
        <h3 id="modal-basic-title">
          Edit Purchase Details
        </h3>
      </div>
      <button (click)="modal.dismiss('Cross click');clear_purchase()" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div *ngIf="user_rights.ADD == '1'" class="page-panel">
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="form-group col-lg-3">
                <label>Supplier Name</label><span class="text-danger">&nbsp;*</span>
                <ngx-select-dropdown (change)="getVendor();listOrderNo();"
                                     [(ngModel)]="vendor_data"
                                     [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select Supplier',searchOnKey: 'VENDOR_NAME'})"
                                     [disabled]="purchase.purchase_id > 0" [multiple]="false"
                                     [options]="vendor_options" class="form-control  select-dropdown"
                                     name="vendor"></ngx-select-dropdown>
              </div>
              <div class="form-group col-lg-3">
                <label>Invoice Number</label><span class="text-danger">&nbsp;*</span>
                <input [(ngModel)]="purchase.invoice_no" [disabled]="purchase.purchase_id > 0"
                       class="form-control " maxlength="15"
                       name="invoice" type="text">
              </div>
              <div class="form-group col-lg-3">
                <label>PO Number</label>
                <ng-multiselect-dropdown (onDeSelectAll)="onSelectAll($event)"
                                         (onSelectAll)=" onSelectAll($event)"
                                         [(ngModel)]="purchase.sor_no"
                                         [data]="order_list"
                                         [disabled]="purchase.purchase_id > 0"
                                         [placeholder]="'Select Order Number'"
                                         [settings]="dropdownSettings"
                                         name="sor_no"
                                         style="font-size: 13px;">
                </ng-multiselect-dropdown>

              </div>
              <div class="form-group col-lg-3">
                <label for="date">Invoice date</label><span class="text-danger">&nbsp;*</span>
                <input (ngModelChange)="purchase.invoice_date = $event" [disabled]="purchase.purchase_id > 0"
                       [max]="getToday()"
                       [ngModel]="purchase.invoice_date | date:'yyyy-MM-dd' "
                       class="form-control " id="date" name="date" type="date">
              </div>
              <div class="form-group col-lg-3">
                <label>VAT No</label>
                <input [(ngModel)]="purchase.customer_trn" [readOnly]="true" class="form-control "
                       maxlength="20" name="customer_trn"
                       tabindex="-1" type="text">
              </div>
              <div class="form-group col-lg-3">
                <label for="Date">Customer Reference</label>
                <input [(ngModel)]="purchase.customer_ref" [readOnly]="true" class="form-control "
                       maxlength="20"
                       name="customer_ref" type="text">
              </div>
              <div class="form-group col-lg-3">
                <label for="Date">Sales Person</label>
                <input [(ngModel)]="purchase.sales_person" [readOnly]="true" class="form-control "
                       maxlength="20"
                       name="sales_person" type="text">
              </div>
              <div class="form-group col-lg-3">
                <label>Attachments</label>
                <div>
                  <input (change)="selectFiles($event)" accept=".jpg, .jpeg, .pdf, .png" id="upload_file" multiple
                         name="upload_file"
                         type="file">
                  <div class="clearfix"></div>
                  <ng-container *ngIf="fileName">
                    <ng-container *ngFor="let file of fileName;let i=index">
                      <label class="text-primary" style="font-size:11px;"><i
                        class="fa fa-file"></i>&nbsp;&nbsp;{{ file.name }}</label>
                      &nbsp;&nbsp;&nbsp;<button (click)="fileName.splice(i, 1);purchase.upload_file.splice(i, 1);"
                                                class="btn btn-small"
                                                style="font-size:11px;"><i class="fa fa-trash text-danger"></i></button>
                      <div></div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="filelist">
                    <ng-container *ngFor="let file of filelist;let index=index">
                      <label style="font-size:11px;"><a href="{{ attachmentPath(file.ATTACHMENT_TITLE) }}"
                                                        target="_blank" title="{{ file.ATTACHMENT_TITLE }}"><i
                        class="fa fa-file"></i>&nbsp;&nbsp;{{ file.ATTACHMENT_TITLE }}</a>
                        &nbsp;&nbsp;&nbsp;<button
                          (click)="removeFile(file.PURCHASE_ATTACHMENT_ID);filelist.splice(index, 1);"
                          class="btn btn-sm"
                          style="font-size:11px;">
                          <i class="fa fa-trash text-danger"></i></button>
                      </label>
                      <div></div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
            <hr>
            <h5 class="container page-header">Edit Particular</h5>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="form-group">
              <table class="tbl table tbl-sm  table-bordered ">
                <thead>
                <tr class="text-center">
                  <th class="text-center" width="1%"> Sl</th>
                  <th>Item<span class="text-danger">*</span></th>
                  <th width="10%">UOM / PO Qty</th>
                  <th width="10%"><span class="text-danger">&nbsp;*</span>Purchased Qty / Freebie Qty</th>
                  <th width="10%"><span class="text-danger">&nbsp;*</span> Amount / Actual Rate</th>
                  <ng-container *ngIf="purchase.state_code != 32">
                    <th width="10%"> VAT % / VAT Amount</th>
                  </ng-container>
                  <th width="10%"><span class="text-danger">&nbsp;*</span> Gross Amount / Unit Price<span
                    class="text-danger">&nbsp;*</span></th>
                  <th width="7%"> Selling Price / Ava.Qty <span class="text-danger">&nbsp;*</span></th>
                  <th width="7%">Adjustable Qty<span class="text-danger">&nbsp;*</span></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let purchases of purchase_details;let i = index;">
                  <td class="text-center">{{ i + 1 }}</td>
                  <td>
                    <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="purchase.medicine_data[i]"
                           [class.is-invalid]="searchFailed" [disabled]="purchases.check == false"
                           [inputFormatter]="formatter"
                           [ngModelOptions]="{standalone: true}" [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
                           class="form-control" id="typeahead-http{{i}}"
                           placeholder="Search Particular Name...." style="height: 29px;margin-bottom: 2px"
                           type="text"/>
                    <select [(ngModel)]="purchase.warehouse[i]"
                            class="form-control  custom-select custom-select-sm"
                            name="warehouse{{i}}">
                      <option value="">Select Warehouse</option>
                      <option *ngFor="let data of warehouse" class="ng-tns-c13-1 ng-star-inserted"
                              value="{{data.WAREHOUSE_ID}}">{{ data.WAREHOUSE_NAME }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input [(ngModel)]="purchase.uom_arr_name[i]" [readOnly]="true"
                           class="form-control  "
                           name="uom_arr_name{{i}}" style="margin-bottom: 2px" tabindex="-1"
                           type="text">
                    <input [(ngModel)]="purchase.order_quantity[i]" [readOnly]="true"
                           class="form-control text-center " maxlength="8"
                           name="order_quantity{{i}}" tabindex="-1" type="text">
                  </td>
                  <td>
                    <input (focusout)="getActualPrice();getUnitPrice();checkQuantity()"
                           [(ngModel)]="purchase.purchased_quantity_arr[i]" [readOnly]="true"
                           class="form-control text-center " maxlength="8"
                           name="purchased_quantity_arr{{i}}" style="margin-bottom: 2px"
                           tabindex="-1" type="text">
                    <input (focusout)="getActualPrice()" [(ngModel)]="purchase.freebie_arr[i]" [readOnly]="true"
                           class="form-control text-center " maxlength="8" name="freebie_arr{{i}}"
                           tabindex="-1" type="text">
                  </td>
                  <td>
                    <input (focusout)="getUnitPrice(); getAmount();getActualPrice();totalAmount()"
                           [(ngModel)]="purchase.amount_arr[i]" class="form-control text-right "
                           maxlength="10"
                           name="amount_arr{{i}}" style="margin-bottom: 2px"
                           type="text">
                    <input [(ngModel)]="purchase.actual_arr[i]" [readonly]="true"
                           class="form-control text-right " maxlength="10"
                           name="actual_arr{{i}}" style="margin-bottom: 2px" tabindex="-1"
                           type="text">

                  </td>
                  <ng-container>
                    <td>
                      <input (focusout)=" getAmount();totalAmount()" [(ngModel)]="purchase.vat_amt_arr[i]"
                             [readOnly]="true"
                             class="form-control  text-right " maxlength="7"
                             name="vat{{i}}" style="margin-bottom: 2px" tabindex="-1"
                             type="text">
                      <input (focusout)=" getAmount();totalAmount()" [(ngModel)]="purchase.vat_amt_arr[i]"
                             [readOnly]="true"
                             class="form-control text-right " maxlength="7"
                             name="vat{{i}}" tabindex="-1" type="text">
                    </td>
                  </ng-container>
                  <td>
                    <input [(ngModel)]="purchase.gross_arr[i]" [readOnly]="true"
                           class="form-control  text-right " maxlength="7"
                           name="vat_arr{{i}}" style="margin-bottom: 2px" tabindex="-1"
                           type="text">
                    <input [(ngModel)]="purchase.unitprice_arr[i]" [readOnly]="true"
                           class="form-control  text-right " maxlength="7"
                           name="unitprice_arr{{i}}" tabindex="-1" type="text">
                  </td>
                  <td>
                    <input [(ngModel)]="purchase.retailprice_arr[i]" [readOnly]="true"
                           class="form-control text-right  " maxlength="7"
                           name="retailprice_arr{{i}}" style="margin-bottom: 2px" tabindex="-1"
                           type="text">
                    <input [(ngModel)]="purchase.ava_qty_arr[i]" [readonly]="true"
                           class="form-control text-center  " maxlength="7"
                           name="retailprice_arr{{i}}" tabindex="-1" type="text"
                    >
                  </td>
                  <td>
                    <input (keydown)="changeCalculation(i);validateNumber($event)" (keyup)="changeCalculation(i)"
                           [(ngModel)]="purchase.edit_qty_arr[i]" class="form-control "
                           id="{{i+1}}" maxlength="7" name="edit_qty_arr{{i}}"
                           type="text">
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <ng-container *ngIf="purchase.state_code != 32">
                  <tr>
                    <td colspan="8" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
                    <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
                  </tr>
                  <tr>
                    <td colspan="6" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
                    <td>
                      <input (focusout)="totalAmount()" [(ngModel)]="purchase.freight_charge"
                             class="form-control text-right "
                             maxlength="9" name="freight" style="height:33px"
                             type="text">
                    </td>
                    <td style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
                    <div class="input-group mb-2">
                      <input (focusout)="totalAmount()" [(ngModel)]="purchase.disc_per"
                             class="form-control text-right "
                             maxlength="8" name="dis_arr" style="height:33px"
                             type="text">
                      <div class="input-group-append">
                        <label class="input-group-text day">
                          (%)
                        </label>
                      </div>
                    </div>
                    <input (focusout)="totalAmount()" [(ngModel)]="purchase.discount" [readonly]="true"
                           class="form-control text-right " maxlength="8" name="dis_arr"
                           style="height:33px" type="text">
                  </tr>
                  <tr>
                    <td colspan="8" style="text-align: right"><label>Net Total ({{env.CURRENCY}})&nbsp;&nbsp;&nbsp;</label>
                    </td>
                    <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="purchase.state_code == 32">
                  <tr>
                    <td colspan="9" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
                    <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
                  </tr>
                  <tr>
                    <td colspan="7" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
                    <td>
                      <input (focusout)="totalAmount()" [(ngModel)]="purchase.freight_charge"
                             class="form-control text-right "
                             maxlength="9" name="freight" style="height:33px"
                             type="text">
                    </td>
                    <td style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
                    <div class="input-group mb-2">
                      <input (focusout)="totalAmount()" [(ngModel)]="purchase.disc_per"
                             class="form-control text-right "
                             maxlength="7" name="dis_arr" style="height:33px"
                             type="text">
                      <div class="input-group-append">
                        <label class="input-group-text day">
                          (%)
                        </label>
                      </div>
                    </div>
                    <input (focusout)="totalAmount()" [(ngModel)]="purchase.discount" [readonly]="true"
                           class="form-control text-right " maxlength="8" name="dis_arr"
                           style="height:33px" type="text">
                  </tr>
                  <tr>
                    <td colspan="9" style="text-align: right"><label>Net Total ({{env.CURRENCY}})&nbsp;&nbsp;&nbsp;</label>
                    </td>
                    <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
                  </tr>
                </ng-container>
                </tfoot>

              </table>
              <table>

              </table>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <hr>
            <div class="clearfix"></div>

            <div class="row container">
              <div class="col-lg-7 pull-right">
                <button (click)="UpdatePurchase();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Save&nbsp;</button>
              </div>
            </div>
            <div style="height:100px"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #vat let-modal>
    <div class="modal-header">
      <div class="pull-right ">
        <h5 class="modal-title" id="modal-basic-title">
          VAT Credit
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="form-group col-lg-12">
            <label for="date">VAT Credit</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <label class="checkbox-inline">
              <input (click)="selectVatcredit(1)" [checked]="purchase_credit.vat_credit == 1" id="Yes" name="vat_price"
                     type="radio"
                     value="1">&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </label>
            <label class="checkbox-inline">
              <input (click)="selectVatcredit(0)" [checked]="purchase_credit.vat_credit == 0" id="No" name="vat_price"
                     type="radio"
                     value="0">&nbsp;&nbsp;No
            </label>
          </div>
          <div class="form-group col-lg-12">
            <label for="date">Credit Date</label>
            <input (ngModelChange)="purchase_credit.credit_date = $event" [max]="getToday()"
                   [ngModel]="purchase_credit.credit_date | date:'yyyy-MM-dd' "
                   class="form-control " id="credit_date" name="credit_date"
                   type="date">
          </div>
          <div class="clearfix"></div>
          <div class="form-group text-center col-lg-12">
            <button (click)="modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-warning btn  btn-sm ng-star-inserted"
                    style="color:#fff">Cancel
            </button>&nbsp;&nbsp;&nbsp;
            <button (click)="saveVATCredit();modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-info btn  btn-sm ng-star-inserted">Save
            </button>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #payment let-modal>
    <div class="modal-header">
      <div class="pull-right ">
        <h5 class="modal-title" id="modal-basic-title">
          Received Details
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="row">
            <div class=" col-lg-5">
              <label>Received</label>
            </div>
            <div class=" col-lg-7">
              <label class="checkbox-inline">
                <input (click)="selectpaymentcredit(1)" [checked]="purchase_received.received == 1" id="Yes"
                       name="payment_price" type="radio"
                       value="1">&nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </label>
              <label class="checkbox-inline">
                <input (click)="selectpaymentcredit(0)" [checked]="purchase_received.received == 0" id="No"
                       name="payment_price" type="radio"
                       value="0">&nbsp;&nbsp;No
              </label>
            </div>
            <div class="clearfix"></div>
            <div class=" col-lg-5">
              <label for="date">Received Date</label>
            </div>
            <div class=" col-lg-7">
              <input (ngModelChange)="purchase_received.received_date = $event"
                     [disabled]="purchase_received.received == 0" [max]="getToday()"
                     [ngModel]="purchase_received.received_date | date:'yyyy-MM-dd' "
                     class="form-control " id="received_date" name="received_date"
                     type="date">
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="form-group text-center col-lg-12">
            <button (click)="modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-warning btn  btn-sm ng-star-inserted"
                    style="color:#fff">Cancel
            </button>&nbsp;&nbsp;&nbsp;
            <button (click)="savePurchaseReceived(payment);modal.dismiss('Cross click')" *ngIf="user_rights.ADD == '1'"
                    class="btn-info btn  btn-sm ng-star-inserted">Save
            </button>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #content let-modal>
    <div class="modal-header">
      <div class="pull-right">
        <h3 class="modal-title" id="modal-basic-title">
          Particular List
        </h3>
      </div>
      <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="tab-pane active">
        <div class="tab-content">
          <div class="panel panel-default">
            <div class="panel-heading">


            </div>
          </div>
          <div class="panel-body">
          <div *ngIf="purchased" class="row">

            <div class="col-lg-4">
              <div class="row">
                <div class="col-lg-4">
                  <label>Supplier Name</label>
                </div>
                <div class="col-lg-8">
                  :&nbsp;<span class="tle">{{ purchased.VENDOR_NAME }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="row">
                <div class="col-lg-3">
                  <label>Invoice Date</label>
                </div>
                <div class="col-lg-8">
                  :&nbsp; <span class="tle">{{ purchased.INVOICE_DATE | date:'dd/MM/yyyy' }}</span>
                </div>
              </div>
            </div>
            <div class="col-lg-4" *ngIf="purchased.GRN_NUMBER">
              <div class="row">
                <div class="col-lg-3">
                  <label>GRN No.</label>
                </div>
                <div class="col-lg-8">
                  :&nbsp; <span class="tle">{{ purchased.GRN_NUMBER }}</span>
                </div>
              </div>
            </div>

          </div>
          

            <table class="table tbl table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th>Sl</th>
                <th width="25%">Particular</th>
                <th width="5%">Purchased qty</th>
                <th width="5%">Freebie qty</th>
                <th>Total Qty</th>
                <th>UOM</th>
                <th>Unit Price</th>
                <th>Retail Price</th>
                <th>Amount</th>
                <th>VAT Amount</th>
                <th>Gross Amount</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of item_list;let i=index">
                <td class="text-center">{{ 1 + i }}</td>
                <td> {{ item.TRADE_NAME }}</td>
                <td>{{ item.PURCHASED_QUANTITY }}</td>
                <td>{{ item.FREEBIE_QUANTITY }}</td>
                <td>{{ item.QUANTITY }}</td>
                <td>{{ item.UNIT_DESC }}</td>
                <td class="text-right">{{ item.UNIT_PRICE }}</td>
                <td class="text-right">{{ item.MRP }}</td>
                <td class="text-right">{{ item.AMOUNT }}</td>
                <td class="text-right">{{ item.VAT_AMOUNT }}</td>
                <td class="text-right">{{ item.GROSS_AMOUNT }}</td>
                <td>
                  <button (click)="generateBarcode(item);bar(barcode);" class="btn btn-sm"
                          style="font-size:15px;color :rgb(0, 140, 255)" title="Generate barcode">
                    <i class="fa fa-barcode"></i></button>
                </td>
              </tr>
              <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE == 32">
                <tr>
                  <td class="text-right" colspan="11">Gross Total</td>
                  <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Freight Charge</td>
                  <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Discount</td>
                  <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Net Total ({{env.CURRENCY}})</td>
                  <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="purchased && purchased.VENDOR_STATECODE  != 32">
                <tr>
                  <td class="text-right" colspan="11">Gross Total</td>
                  <td class="text-right">{{ price_total |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Freight Charge</td>
                  <td class="text-right">{{ purchased.FREIGHT_CHARGE |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Discount</td>
                  <td class="text-right">{{ purchased.DISCOUNT |  number : '1.2-2' }}</td>
                </tr>
                <tr *ngIf="purchased">
                  <td class="text-right" colspan="11">Net Total ({{env.CURRENCY}})</td>
                  <td class="text-right">{{ net_total |  number : '1.2-2' }}</td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #barcode let-modal>
    <div class="modal-header">
      <div class="pull-right ">
        <h5 class="modal-title" id="modal-basic-title">
          Generate Bar code
        </h5>
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">

      <div *ngFor="let PS of print_barcode" class="text-center">
        <ngx-barcode6
          [bc-display-value]="true"
          [bc-format]="'pharmacode'"
          [bc-value]="PS.PURCHASE_DETAILS_ID"
        />
      </div>
      <div class="clearfix"></div>
      <div class="clearfix"></div>
      <div class="row">
        <div class="col-5">
          <label>No of Labels</label>
        </div>
        <div class="col-7">
          <input (change)="printCount(count)" [(ngModel)]="count" class="form-control text-right "
                 maxlength="7"
                 name="count" type="text">
        </div>
      </div>


    </div>
    <div class="modal-footer">
      <button (click)="modal.dismiss('Cross click');" class="btn-danger btn  btn-sm ng-star-inserted">Cancel</button>
      <button (click)="printBarcode()" class="btn-info btn  btn-sm ng-star-inserted"
              title="Generate barcode">Print
      </button>
    </div>
  </ng-template>

  <div id="printBarcode" style="display:none">

    <ng-container *ngFor="let i of count_arr">
      <ngx-barcode6
        *ngFor="let PS of print_barcode"
        [bc-display-value]="true"
        [bc-format]="'pharmacode'"
        [bc-value]="PS.PURCHASE_DETAILS_ID"
        id="barcode-{{i}}"
      ></ngx-barcode6>
    </ng-container>
  </div>

  <ng-template #files let-modal>
    <div *ngIf="file_list" class="modal-header">
      <div class="pull-right">
        <h4 class="modal-title" id="modal-basic-title">
          Attachment List
        </h4>
      </div>
      <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </div>
      <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="file_list">
        <ng-container *ngFor="let file of file_list">
          <div class="col-2"></div>
          <div class="col-10">
            <div><a href="{{ attachmentPath(file.ATTACHMENT_TITLE) }}" target="_blank"
                    title="{{ file.ATTACHMENT_TITLE }}"><i
              class="fa fa-file"></i>&nbsp;&nbsp;{{ file.ATTACHMENT_TITLE }}</a></div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!file_list">
        <div class="text-center text-danger">No attachment in this purchase.
          <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </ng-container>
    </div>

  </ng-template>
</div>
